import {eatalianoAxios} from "@/data/api/http/axios";
import {ExternalFileDownload} from "@/data/entities/storage";

export const getExternalFileDownloadUrl = (
    externalFileId: number,
): Promise<ExternalFileDownload> => (
    eatalianoAxios
        .get(`/storage/${externalFileId}`)
        .then(response => response.data)
);
